// Unsplash image URLs - replace with /images/your-image.jpg when you add local images
export const IMAGES = {
  hero: [
    "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=1920&q=80",
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80",
    "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1920&q=80",
    "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1920&q=80",
  ],
  about:
    "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80",
  caseStudies: [
    "https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&q=80",
    "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=600&q=80",
    "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80",
  ],
  blog: [
    "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&q=80",
    "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=600&q=80",
    "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=600&q=80",
  ],
  blogPage: [
    "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&q=80",
    "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=600&q=80",
    "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=600&q=80",
    "https://images.unsplash.com/photo-1551431009-a22ee0f4040d?w=600&q=80",
    "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80",
    "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&q=80",
    "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=600&q=80",
    "https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&q=80",
    "https://images.unsplash.com/photo-1551431009-a22ee0f4040d?w=600&q=80",
  ],
  aboutPage:
    "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80",
  coverage:
    "https://images.unsplash.com/photo-1524661135-423995f22d0b?w=1200&q=80",
  heroPrivacy:
    "https://images.unsplash.com/photo-1518770660439-4636190af475?w=1920&q=80",
  heroContact:
    "https://images.unsplash.com/photo-1525182008055-f88b95ff7980?w=1920&q=80",
  heroCoverage:
    "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=1920&q=80",
  contactIllustration:
    "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1200&q=80",
  heroAbout:
    "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=1920&q=80",
};
